/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendClientMonthlyReportRequest
 */
export interface SendClientMonthlyReportRequest {
    /**
     * Month of the report as `YYYY-MM`. Defaults to the previous month.
     */
    month?: string;
}

/**
 * Check if a given object implements the SendClientMonthlyReportRequest interface.
 */
export function instanceOfSendClientMonthlyReportRequest(value: object): value is SendClientMonthlyReportRequest {
    return true;
}

export function SendClientMonthlyReportRequestFromJSON(json: any): SendClientMonthlyReportRequest {
    return SendClientMonthlyReportRequestFromJSONTyped(json, false);
}

export function SendClientMonthlyReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendClientMonthlyReportRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'month': json['month'] == null ? undefined : json['month'],
    };
}

export function SendClientMonthlyReportRequestToJSON(json: any): SendClientMonthlyReportRequest {
    return SendClientMonthlyReportRequestToJSONTyped(json, false);
}

export function SendClientMonthlyReportRequestToJSONTyped(value?: SendClientMonthlyReportRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'month': value['month'],
    };
}

